import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/core/material';

import { BranchRoutingModule } from './branch-routing.module';
import { BranchComponent } from './branch.component';
import { AddBranchComponent } from './add-branch/add-branch.component';
import { UpdateBranchComponent } from './update-branch/update-branch.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { MatInputModule, MatButtonModule, MatSelectModule, MatCardModule,
         MatAutocompleteModule, MatIconModule, MatProgressBarModule } from '@angular/material';
import { NgMatAutocompleteModule } from 'src/app/shared/components/autocomplete/autocomplete.module';
import { ViewDetailBranchComponent } from './view-detail-branch/view-detail-branch.component';

@NgModule({
  declarations: [
    BranchComponent,
    AddBranchComponent,
    UpdateBranchComponent,
    ViewDetailBranchComponent
  ],
  imports: [
    CommonModule,
    BranchRoutingModule,
    MaterialModule,
    FormsModule,
    SharedModule,
    TranslateModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatCardModule,
    MatAutocompleteModule,
    MatIconModule,
    MatProgressBarModule,
    NgMatAutocompleteModule
  ],
  entryComponents: [
    AddBranchComponent,
    UpdateBranchComponent,
    ViewDetailBranchComponent
  ],
})
export class BranchModule { }
